import React from 'react';
import NavBar from './NavBar';
import Footer from './Footer';
import '../styles/AllVideoPage.css';
import FunctionIcon from './FunctionIcon';
import {
  TrendingUpSharp,
  ThumbsUpDownSharp,
  CommentSharp,
  QueuePlayNextOutlined,
  PlayCircleFilled,
} from '@material-ui/icons';
import VideoCard from './VideoCard';
import { Grid, Box } from '@material-ui/core';
import Pagination from '@material-ui/lab/Pagination';

const AllVideosPage = () => {
  return (
    <>
      <NavBar />
      <div className="allvideopage">
        <div className="allvideopage__add">
          <h1>Add</h1>
        </div>

        <div className="allvideopage__functionicons">
          <h1>Videos</h1>
          <div className="allvideopage__icons">
            <FunctionIcon selected Icon={PlayCircleFilled} name="Recent" />
            <FunctionIcon Icon={TrendingUpSharp} name="Top" />
            <FunctionIcon Icon={ThumbsUpDownSharp} name="Liked" />
            <FunctionIcon Icon={CommentSharp} name="Commented" />
            <FunctionIcon Icon={QueuePlayNextOutlined} name="Pics" />
          </div>
        </div>
        <Box mt={5}>
          <Grid container spacing={3}>
            <Grid item lg={3} md={4} sm={6}>
              <VideoCard
                videoImg="https://i.ytimg.com/vi/ggJMQHltiQc/maxresdefault.jpg"
                videoTitle="Title"
                description="Description"
                views="64"
                timestamp="12 days agp"
                videoDuration="02:18"
              />
            </Grid>
            <Grid item lg={3} md={4} sm={6}>
              <VideoCard
                videoImg="https://i.ytimg.com/vi/ggJMQHltiQc/maxresdefault.jpg"
                videoTitle="Title"
                description="Description"
                views="64"
                timestamp="12 days agp"
                videoDuration="02:18"
              />
            </Grid>{' '}
            <Grid item lg={3} md={4} sm={6}>
              <VideoCard
                videoImg="https://i.ytimg.com/vi/ggJMQHltiQc/maxresdefault.jpg"
                videoTitle="Title"
                description="Description"
                views="64"
                timestamp="12 days agp"
                videoDuration="02:18"
              />
            </Grid>{' '}
            <Grid item lg={3} md={4} sm={6}>
              <VideoCard
                videoImg="https://i.ytimg.com/vi/ggJMQHltiQc/maxresdefault.jpg"
                videoTitle="Title"
                description="Description"
                views="64"
                timestamp="12 days agp"
                videoDuration="02:18"
              />
            </Grid>{' '}
            <Grid item lg={3} md={4} sm={6}>
              <VideoCard
                videoImg="https://i.ytimg.com/vi/ggJMQHltiQc/maxresdefault.jpg"
                videoTitle="Title"
                description="Description"
                views="64"
                timestamp="12 days agp"
                videoDuration="02:18"
              />
            </Grid>{' '}
            <Grid item lg={3} md={4} sm={6}>
              <VideoCard
                videoImg="https://i.ytimg.com/vi/ggJMQHltiQc/maxresdefault.jpg"
                videoTitle="Title"
                description="Description"
                views="64"
                timestamp="12 days agp"
                videoDuration="02:18"
              />
            </Grid>{' '}
            <Grid item lg={3} md={4} sm={6}>
              <VideoCard
                videoImg="https://i.ytimg.com/vi/ggJMQHltiQc/maxresdefault.jpg"
                videoTitle="Title"
                description="Description"
                views="64"
                timestamp="12 days agp"
                videoDuration="02:18"
              />
            </Grid>{' '}
            <Grid item lg={3} md={4} sm={6}>
              <VideoCard
                videoImg="https://i.ytimg.com/vi/ggJMQHltiQc/maxresdefault.jpg"
                videoTitle="Title"
                description="Description"
                views="64"
                timestamp="12 days agp"
                videoDuration="02:18"
              />
            </Grid>{' '}
            <Grid item lg={3} md={4} sm={6}>
              <VideoCard
                videoImg="https://i.ytimg.com/vi/ggJMQHltiQc/maxresdefault.jpg"
                videoTitle="Title"
                description="Description"
                views="64"
                timestamp="12 days agp"
                videoDuration="02:18"
              />
            </Grid>{' '}
            <Grid item lg={3} md={4} sm={6}>
              <VideoCard
                videoImg="https://i.ytimg.com/vi/ggJMQHltiQc/maxresdefault.jpg"
                videoTitle="Title"
                description="Description"
                views="64"
                timestamp="12 days agp"
                videoDuration="02:18"
              />
            </Grid>{' '}
            <Grid item lg={3} md={4} sm={12}>
              <VideoCard
                videoImg="https://i.ytimg.com/vi/ggJMQHltiQc/maxresdefault.jpg"
                videoTitle="Title"
                description="Description"
                views="64"
                timestamp="12 days agp"
                videoDuration="02:18"
              />
            </Grid>{' '}
            <Grid item lg={3} md={4} sm={12}>
              <VideoCard
                videoImg="https://i.ytimg.com/vi/ggJMQHltiQc/maxresdefault.jpg"
                videoTitle="Title"
                description="Description"
                views="64"
                timestamp="12 days agp"
                videoDuration="02:18"
              />
            </Grid>{' '}
          </Grid>
        </Box>

        <div className="pagination">
          <Pagination
            size="large"
            count={10}
            shape="rounded"
            color="secondary"
          />
        </div>

        <Footer />
      </div>
    </>
  );
};

export default AllVideosPage;
